module.exports = __webpack_public_path__ + "static/media/reserva-libros.ac35fa98.png";